import { ReloadOutlined, SearchOutlined } from "@ant-design/icons";
import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Card, Col, Form, Row, Space } from "antd";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { CustomInput } from "../../../shared/formFields/CustomInput";
import { CustomSelectField } from "../../../shared/formFields/CustomSelectField";
import { CustomCheckbox } from "../../../shared/formFields/CustomCheckbox";
import { clearRenewalsSearch } from "../../../store/renewalsSearch/renewalsSearchSlice";
import { searchRenewals } from "../../../store/renewalsSearch/renewalsSearchThunks";
import RenewalsSearchTable from "./RenewalsSearchTable";
import { renewalsSearchSchema } from "./renewalsSearchSchema";

// Only 2 search types now
const SEARCH_BY_OPTIONS = [
  { label: "Insured Name", value: "insured_name" },
  { label: "Customer Code", value: "customer_code" },
];

const initialValues = {
  // removed date_range
  search_type: "insured_name", // default Insured Name
  search_criteria: "", // default empty

  // checkbox defaults
  include_not_sent: true,
  include_sent: true,
  include_cancelled: false,
  include_completed: false,
};

const RenewalsSearch = () => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { isValid },
  } = useForm({
    mode: "onSubmit",
    defaultValues: initialValues,
    values: initialValues,
    shouldFocusError: false,
    resetOptions: {
      keepDirty: false,
      keepDirtyValues: false,
      keepErrors: true,
    },
    resolver: yupResolver(renewalsSearchSchema),
  });

  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.renewalsSearch.isLoading);

  const onFinish = (values) => {
    // values already match the thunk signature
    dispatch(searchRenewals(values));
  };

  useEffect(() => {
    dispatch(searchRenewals(initialValues));
    return () => {
      dispatch(clearRenewalsSearch());
    };
  }, [dispatch]);

  return (
    <div>
      <Card className="body-card-content-no-min-height">
        <Form
          name="renewals_search"
          autoComplete="off"
          size="small"
          labelWrap
          layout="horizontal" // make everything flow left-to-right
          onFinish={() => handleSubmit(onFinish)()}
        >
          {/* Include checkboxes */}
          <Row gutter={12}>
            <Col flex="0 1 320px">
              <Form.Item label="Include">
                <Row gutter={8}>
                  <Col flex="0 1 110px">
                    <CustomCheckbox control={control} name="include_not_sent">
                      Not Sent
                    </CustomCheckbox>
                  </Col>
                  <Col flex="0 1 110px">
                    <CustomCheckbox control={control} name="include_sent">
                      Sent
                    </CustomCheckbox>
                  </Col>
                </Row>
                <Row gutter={8}>
                  <Col flex="0 1 110px">
                    <CustomCheckbox control={control} name="include_cancelled">
                      Cancelled
                    </CustomCheckbox>
                  </Col>
                  <Col flex="0 1 110px">
                    <CustomCheckbox control={control} name="include_completed">
                      Completed
                    </CustomCheckbox>
                  </Col>
                </Row>
              </Form.Item>
            </Col>
            <Col flex="0 1 320px">
              <Form.Item label="Search By">
                <CustomSelectField
                  options={SEARCH_BY_OPTIONS}
                  style={{ width: 160 }}
                  control={control}
                  name="search_type"
                  placeholder="Search By"
                />
              </Form.Item>
            </Col>
            <Col flex="0 1 330px">
              <Form.Item label="Search Criteria">
                <CustomInput
                  control={control}
                  style={{ width: 220 }}
                  name="search_criteria"
                  placeholder="Search Criteria"
                />
              </Form.Item>
            </Col>
          </Row>

          <div style={{ textAlign: "right" }}>
            <Space size="small">
              <Button
                style={{ width: 90 }}
                type="primary"
                size="small"
                htmlType="submit"
                disabled={!isValid || isLoading}
              >
                <SearchOutlined /> Search
              </Button>
              <Button
                style={{ width: 90 }}
                size="small"
                onClick={() => {
                  reset(initialValues);
                  dispatch(searchRenewals(initialValues));
                }}
              >
                <ReloadOutlined /> Reset
              </Button>
            </Space>
          </div>
        </Form>
      </Card>

      <Card className="body-card-content-no-min-height">
        <RenewalsSearchTable />
      </Card>
    </div>
  );
};

export default RenewalsSearch;
